module.exports = __webpack_public_path__ + "static/media/mace-logo.2ef70203.svg";